import { Control } from 'react-hook-form';

import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';

import {
  DistanceRangeFromField,
  DistanceRangeToField,
  ExpensesMaxField,
  ExpensesNominalField,
  ExpensesPerDistanceField,
  ValidFromField,
  ValidToField
} from './innerView/editTravelLines/components/TravelLineFields';
import {
  GridContainer,
  GridCompact4,
  GridCompact6
} from 'components/shared/Grid/Grid.components';

interface Props {
  control: Control<any>;
}

const DetailsArrangementSection: React.FC<Props> = ({ control }) => {
  return (
    <MultiStepForm.Section title={'Details'}>
      <GridContainer>
        <GridCompact6>
          <DistanceRangeFromField name={`travelSetLine.distanceRangeFrom`} />
        </GridCompact6>
        <GridCompact6>
          <DistanceRangeToField name={`travelSetLine.distanceRangeTo`} />
        </GridCompact6>
        <GridCompact4>
          <ExpensesPerDistanceField
            name={`travelSetLine.expensesPerDistance`}
          />
        </GridCompact4>
        <GridCompact4>
          <ExpensesNominalField name={`travelSetLine.expensesNominal`} />
        </GridCompact4>
        <GridCompact4>
          <ExpensesMaxField name={`travelSetLine.expensesMax`} />
        </GridCompact4>
        <GridCompact6>
          <ValidFromField name={`travelSetLine.from`} control={control} />
        </GridCompact6>
        <GridCompact6>
          <ValidToField name={`travelSetLine.to`} control={control} />
        </GridCompact6>
      </GridContainer>
    </MultiStepForm.Section>
  );
};

export default DetailsArrangementSection;
